import { 
	is__func, 
	isset 
} from './_general';

import {
	unpin
} from '../section/_header';

const DEFAULT__SCROLL_FIRST_ELEMENT_DURATION = 1250;
const DEFAULT__SCROLL_FIRST_ELEMENT_OFFSET = -100;
const DEFAULT__SCROLL_FIRST_ELEMENT_TRIGGER = '[data-scroll-to="CE_FIRST"]';

const DEFAULT__SELECTOR_CE = 'body>main .ce';
const DEFAULT__OFFSET = -75;

function scroll__to_anchor(this_obj, target, base_speed, offset) {
	
	var this_offset = this_obj.offset();
	var that_offset = target.offset();
	var offset_diff = Math.abs(that_offset.top - this_offset.top);
 
	var speed = (offset_diff * base_speed) / 1000;
	
	if(!isset(offset)) {
		offset = DEFAULT__OFFSET;
	}
	
	
	$("html,body")
		.velocity('stop')
		.velocity("scroll", {
			easing: 'easeInExpo', 
			duration:speed,
			offset: that_offset.top,
			complete: function() {
				setTimeout(function() {
					unpin();
				},500);
				
			}
	});

}


function scroll__to_first_content_element(duration,offset,trigger,target,callback) {
		
		if(!isset(duration)) {
			duration = DEFAULT__SCROLL_FIRST_ELEMENT_DURATION;
		}
		
		if(!isset(offset)) {
			offset = DEFAULT__OFFSET;
		}
		
		if(!isset(target)) {
			target = DEFAULT__SELECTOR_CE;
		}
		
		if(!isset(trigger)) {
			trigger = DEFAULT__SCROLL_FIRST_ELEMENT_TRIGGER;
		}
		
		
		
		$(trigger).bind('click', function(event) {
			event.preventDefault();
			
			$(target).first()
				.velocity('stop')
				.velocity("scroll", {
					easing:'easeInExpo', 
					duration:duration,
					offset: offset,
					complete: function() {
						if(is__func(callback)) {
							callback();
						}
					}
			});
			
		});
		
};
			
			
			
export {
	scroll__to_anchor,
	scroll__to_first_content_element
};